import { useSiteSettings } from '@/hooks/useSiteSettings';
import { resolveSlotImage } from '@/lib/siteImages';

interface SlotImageProps {
  slot: string;
  fallback: string;
  alt: string;
  className?: string;
}

/**
 * Renders a website image that admins can replace from Site Settings.
 * Falls back to the supplied real photo when no override is saved.
 */
export default function SlotImage({ slot, fallback, alt, className }: SlotImageProps) {
  const { data } = useSiteSettings();
  const src = resolveSlotImage(data, slot, fallback);
  return <img src={src} alt={alt} className={className} />;
}